var isProd = true;

if (window.location.hostname === 'api.uzhan.3dwangzhan.com/' && window.location.port === '') {
    isProd = true;
}

export const host = 'https://api.uzhan.3dwangzhan.com';
